(function() {
    function init() {
        let isScrolled = false;
        const header = document.querySelector('theme-header');
        const headerColumns = document.querySelector('theme-header .small-12');
        const logo_nav = document.querySelector('theme-header .logolink.logo-navbar');
        const logo_luxury = document.querySelector('theme-header .logolink.luxury-logo');
        const menuItems = document.querySelectorAll('theme-header .top-level-menu-item');
        menuItems.forEach(item => {
            item.addEventListener('mouseenter', () => {
                if (!isScrolled && header) {
                    header.classList.add('menu-hover');
                }
            });

            item.addEventListener('mouseleave', () => {
                if (!isScrolled && header) {
                    header.classList.remove('menu-hover');
                }
            });
        });

        function handleScrollChange() {
            const scrollTop = window.scrollY || window.pageYOffset || 0;
            if (scrollTop > 20 && !isScrolled) {
                isScrolled = true;
                if (logo_nav) {
                    logo_nav.classList.add("block");
                }
                if (logo_luxury) {
                    logo_luxury.classList.add("none");
                }
                if (header) {
                    header.classList.remove('header-transparent');
                    header.classList.add('transform-svg');
                    header.classList.remove('menu-hover');
                }
                if (headerColumns) {
                    headerColumns.classList.remove('columns-transparent-header');
                    headerColumns.classList.add('columns');
                }
            } else if (scrollTop <= 20 && isScrolled) {
                isScrolled = false;

                if (logo_nav) {
                    logo_nav.classList.add("none");
                }
                if (logo_luxury) {
                    logo_luxury.classList.remove("block");
                }
                if (header) {
                    header.classList.add('header-transparent');
                    header.classList.remove('transform-svg');
                    logo_nav.classList.remove("block");
                    logo_nav.classList.remove("none");
                }
                if (headerColumns) {
                    headerColumns.classList.add('columns-transparent-header');
                    headerColumns.classList.remove('columns');
                    logo_nav.classList.remove("block");
                    logo_nav.classList.remove("none");
                }
            }
        }
        let ticking = false;
        function requestTick(eventType) {
            if (!ticking) {
                window.requestAnimationFrame(function () {
                    handleScrollChange();
                    ticking = false;
                });
                ticking = true;
            }
        }
        window.addEventListener('scroll', function() { requestTick('scroll'); }, { passive: true });
        window.addEventListener('touchmove', function() { requestTick('touchmove'); }, { passive: true });
        window.addEventListener('touchstart', function() { requestTick('touchstart'); }, { passive: true });
        window.addEventListener('touchend', function() { requestTick('touchend'); }, { passive: true });
    }
    
    if (document.readyState !== 'loading') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
        window.addEventListener('load', init);
        setTimeout(init, 100);
    }
})();
